/* tslint:disable */
/* eslint-disable */
/**
 * Gestionale.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MovimentoMacelloCreateDTO
 */
export interface MovimentoMacelloCreateDTO {
    /**
     * 
     * @type {number}
     * @memberof MovimentoMacelloCreateDTO
     */
    quantita?: number;
    /**
     * 
     * @type {string}
     * @memberof MovimentoMacelloCreateDTO
     */
    note?: string | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoMacelloCreateDTO
     */
    valoreFixed?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoMacelloCreateDTO
     */
    idCapannone?: number | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoMacelloCreateDTO
     */
    idTipoAnimale?: number;
    /**
     * 
     * @type {Date}
     * @memberof MovimentoMacelloCreateDTO
     */
    dataMacellazione?: Date | null;
    /**
     * 
     * @type {number}
     * @memberof MovimentoMacelloCreateDTO
     */
    capi?: number;
}

/**
 * Check if a given object implements the MovimentoMacelloCreateDTO interface.
 */
export function instanceOfMovimentoMacelloCreateDTO(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function MovimentoMacelloCreateDTOFromJSON(json: any): MovimentoMacelloCreateDTO {
    return MovimentoMacelloCreateDTOFromJSONTyped(json, false);
}

export function MovimentoMacelloCreateDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): MovimentoMacelloCreateDTO {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'quantita': !exists(json, 'quantita') ? undefined : json['quantita'],
        'note': !exists(json, 'note') ? undefined : json['note'],
        'valoreFixed': !exists(json, 'valoreFixed') ? undefined : json['valoreFixed'],
        'idCapannone': !exists(json, 'idCapannone') ? undefined : json['idCapannone'],
        'idTipoAnimale': !exists(json, 'idTipoAnimale') ? undefined : json['idTipoAnimale'],
        'dataMacellazione': !exists(json, 'dataMacellazione') ? undefined : (json['dataMacellazione'] === null ? null : new Date(json['dataMacellazione'])),
        'capi': !exists(json, 'capi') ? undefined : json['capi'],
    };
}

export function MovimentoMacelloCreateDTOToJSON(value?: MovimentoMacelloCreateDTO | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'quantita': value.quantita,
        'note': value.note,
        'valoreFixed': value.valoreFixed,
        'idCapannone': value.idCapannone,
        'idTipoAnimale': value.idTipoAnimale,
        'dataMacellazione': value.dataMacellazione === undefined ? undefined : (value.dataMacellazione === null ? null : value.dataMacellazione.toISOString()),
        'capi': value.capi,
    };
}

